import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue"

const _hoisted_1 = ["content"]
const _hoisted_2 = ["content"]
const _hoisted_3 = { class: "flex flex-column flex-grow-1 align-items-center md:justify-content-center" }
const _hoisted_4 = { class: "card-form-wrapper md:mt-s10" }
const _hoisted_5 = { class: "card-form" }
const _hoisted_6 = { class: "card-header" }
const _hoisted_7 = { class: "h3 text-bold" }
const _hoisted_8 = { class: "card-content gap-s3" }
const _hoisted_9 = { class: "card-footer" }
const _hoisted_10 = {
  key: 0,
  class: "card-form-append mt-s5"
}
const _hoisted_11 = { class: "flex align-items-center title mb-s3" }

import { computed } from 'vue';
import { Head } from '@vueuse/head';
import { useI18n } from 'vue-i18n';
import { useToggle } from '@/composables/useToggle';
import { seo } from '@/composables/seo/useSeo';
import NetworkPanel from './networkPanel/NetworkPanel.vue';
import BridgeInfo from '@/views/pages/bridge/BridgeInfo.vue';
import TokenIcon from '@/components/token/TokenIcon.vue';
import InfoMessage from '@/components/InfoMessage.vue';
import BridgeConfirmation from '@/views/pages/bridge/confirmation/BridgeConfirmation.vue';
import { useEVMWallet } from '@/store/modules/wallet/useEVMWallet';
import { useCardanoWallet } from '@/store/modules/wallet/useCardanoWallet';
import { useCardanoBridge } from '@/store/modules/bridge/useCardanoBridge';


export default /*#__PURE__*/_defineComponent({
  __name: 'Bridge',
  setup(__props) {

const title = computed(() => seo.value.SEO_BRIDGE?.TITLE ?? '');
const description = computed(() => seo.value.SEO_BRIDGE?.DESCRIPTION ?? '');
const keywords = computed(() => seo.value.SEO_BRIDGE?.KEYWORDS ?? '');

const { t } = useI18n();
const { toggleValue: showConfirmation, setTrue: openDialog, setFalse: closeDialog } = useToggle();
const { walletState } = useEVMWallet();
const cardanoWallet = useCardanoWallet();
const { bridgeForm, doBridge, switchBlockchains } = useCardanoBridge();

if (!cardanoWallet.isInjected) {
  cardanoWallet.init();
}

const isMilkomedaWalletInjected = computed(() => walletState.isInjected);
const isCardanoWalletInjected = computed(() => cardanoWallet.isInjected);
const isAllWalletsInjected = computed(() => {
  return isMilkomedaWalletInjected.value && isCardanoWalletInjected.value;
});

const showBridgeInfo = computed(() => bridgeForm.toAmount?.gt(0));

const fromToken = computed(() => bridgeForm.fromToken.unwrapWETH().symbol);
const toToken = computed(() => bridgeForm.toToken.unwrapWETH().symbol);

const buttonLabel = computed(() => {
  if (!isAllWalletsInjected.value) {
    return t('bridging.connectWallets');
  }

  if (!isMilkomedaWalletInjected.value) {
    return t('bridging.connectMilkomedaWallet');
  }

  if (!isCardanoWalletInjected.value) {
    return t('bridging.connectCardanoWallet');
  }

  return t('bridge');
});

const isBridgeEnabled = computed(
  () => isAllWalletsInjected.value && showBridgeInfo.value && !bridgeForm.errors.length,
);

async function onBridge() {
  closeDialog();
  await doBridge();
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), null, {
      default: _withCtx(() => [
        _createElementVNode("title", null, _toDisplayString(_unref(title)), 1),
        _createElementVNode("meta", {
          property: "description",
          name: "description",
          content: _unref(description)
        }, null, 8, _hoisted_1),
        _createElementVNode("meta", {
          property: "keywords",
          name: "keywords",
          content: _unref(keywords)
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('bridge')), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(NetworkPanel, {
              direction: "from",
              network: _unref(bridgeForm).fromBlockchain
            }, null, 8, ["network"]),
            _createVNode(NetworkPanel, {
              direction: "to",
              network: _unref(bridgeForm).toBlockchain
            }, null, 8, ["network"]),
            _createElementVNode("div", {
              class: "card-form-icon icon-swap mt-s0",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(switchBlockchains) && _unref(switchBlockchains)(...args)))
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Button, {
              label: _unref(buttonLabel),
              class: "w-full button-card-form",
              disabled: !_unref(isBridgeEnabled),
              onClick: _unref(openDialog)
            }, null, 8, ["label", "disabled", "onClick"])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bridgeForm).errors, (error) => {
          return (_openBlock(), _createBlock(InfoMessage, {
            key: error.translationKey,
            type: "danger",
            message: _unref(t)(error.translationKey, error.payload),
            class: "mt-s3",
            "as-panel": ""
          }, null, 8, ["message"]))
        }), 128))
      ]),
      (_unref(showBridgeInfo))
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(TokenIcon, {
                "icon-src": "/images/tokens/milkomeda.svg",
                class: "mr-s1"
              }),
              _createTextVNode(" " + _toDisplayString(_unref(t)('bridging.milkomedaBridge')), 1)
            ]),
            _createVNode(BridgeInfo)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Dialog, {
      visible: _unref(showConfirmation),
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(showConfirmation) ? (showConfirmation).value = $event : null)),
      header: _unref(t)('bridging.confirmationTitle', { fromToken: _unref(fromToken), toToken: _unref(toToken) }),
      modal: true,
      dismissableMask: ""
    }, {
      default: _withCtx(() => [
        _createVNode(BridgeConfirmation, {
          onCancel: _unref(closeDialog),
          onConfirm: onBridge
        }, null, 8, ["onCancel"])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ], 64))
}
}

})